import type { SubFilterI } from 'declarations/interfaces/common';

export const DEFAULT_OEM_FILTERS: SubFilterI[] = [
  { label: 'Ford', value: '351b41b6-0bc4-4052-a247-027032f8af3b', checked: false },
  { label: 'Nissan', value: 'e26c2d7e-f7a8-462f-8ad5-a00d08485dc6', checked: false },
  { label: 'GM', value: '87281043-ce01-4a18-9478-ba49f51f14eb', checked: false },
  { label: 'Kia', value: '0d28dca4-f328-4d67-9c02-9addacebf748', checked: false },
  { label: 'Volkswagen', value: 'afa9a4db-f016-4d80-bbe3-664a5739a374', checked: false },
  { label: 'Honda', value: 'c8d7f7b1-f5b5-4a4a-9a75-e87e117138ab', checked: false },
  { label: 'Volvo', value: 'eb65f958-5ee5-43b6-9981-894f510777d3', checked: false },
  { label: 'Toyota', value: '89a84c56-c714-43c3-9257-bbf22ee2f106', checked: false },
  { label: 'CDJR', value: '9b532565-aa55-43d2-9f5e-56be5daf7f36', checked: false },
  { label: 'Subaru', value: '8c0a6ff2-4d98-4d7a-9ac9-3b58884db193', checked: false },
  { label: 'Hyundai', value: '7a231368-6a5b-4f0e-bf90-41ee5bd54b0f', checked: false },
  { label: 'Mazda', value: 'eec84aad-a02b-43e3-ae7e-570f6c19a369', checked: false },
  { label: 'BMW', value: '3e39d88f-cff2-442e-8fdc-9d346633f7c6', checked: false },
];
